/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Send: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19.8457 3.01195C20.1585 2.96307 20.4794 3.06556 20.7071 3.2932C20.9671 3.55326 21.0636 3.93505 20.958 4.28734L15.5576 22.2873C15.4355 22.6946 15.0693 22.9803 14.6446 22.9993C14.2729 23.0158 13.9276 22.8252 13.7412 22.5129L13.6719 22.3713L10.2305 13.7688L1.62893 10.3284C1.23415 10.1704 0.982071 9.78047 1.001 9.3557C1.01994 8.93094 1.30566 8.56479 1.71291 8.44262L19.7129 3.04222L19.8457 3.01195ZM5.02932 9.53441L10.7588 11.8264L12.0928 10.4934C12.4833 10.1029 13.1163 10.1029 13.5069 10.4934C13.8974 10.8839 13.8974 11.5169 13.5069 11.9075L12.1729 13.2405L14.4649 18.97L18.5078 5.49144L5.02932 9.53441Z'
      fill='currentColor'
    />
  </React.Fragment>
)
